export const useIntegrationsStore = defineStore('integrations', {
  state() {
    return {
      options: [
        'Rest API',
        'Xero',
        'Zendesk',
        'SAP',
        'Salesforce',
        'Quickbooks Intuit',
      ],
    }
  },
  getters: {
    listOptions(state) {
      return state.options
    },
  },
})
